import fullFunctionalityConfig from './fullFunctionalityConfig'

export default {
    ...fullFunctionalityConfig,
    disableAutoSave: true,
    initialSeed: 1000
}
